// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"Spinner_spinnerContainer__6gh3n","spinner":"Spinner_spinner__MzZh7","spin":"Spinner_spin__zwyjL"};